import * as React from 'react';
const SvgHousehold = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      {...props}
    >
      <defs>
        <clipPath id="household_svg__a">
          <path d="M0 .621h24V22H0zm0 0" />
        </clipPath>
      </defs>
      <g clipPath="url(#household_svg__a)">
        <path
          d="M3.664 19.059v-8.051l-1.422 1.066a.836.836 0 01-.625.164.783.783 0 01-.543-.328.772.772 0 01.14-1.129l2.45-1.812v-2.29c0-.23.078-.425.238-.577a.837.837 0 01.602-.235c.238 0 .437.078.598.235.16.152.238.347.238.578v1.047l5.484-4.04a2.068 2.068 0 012.461 0l9.606 7.094c.187.14.293.317.32.528a.828.828 0 01-.176.601.83.83 0 01-.547.313.814.814 0 01-.605-.164l-1.438-1.051v8.05c0 .54-.199 1-.593 1.383a1.99 1.99 0 01-1.43.57H5.687a2.006 2.006 0 01-1.433-.57 1.855 1.855 0 01-.59-1.382zm2.023.332h5.032v-3.45c0-.359.129-.664.386-.914.258-.25.575-.37.95-.37s.691.12.949.37c.254.25.383.555.383.914v3.45h5.035a.348.348 0 00.25-.094.32.32 0 00.094-.238V9.777l-6.508-4.785a.297.297 0 00-.203-.074.29.29 0 00-.203.074L5.34 9.777v9.282c0 .097.035.175.098.238a.348.348 0 00.25.094zm0 0h13.079H5.34zM4.7 4.684a.833.833 0 01-.71-.356c-.173-.238-.192-.488-.055-.742A2.71 2.71 0 014.988 2.34a2.903 2.903 0 011.602-.461c.254 0 .492-.067.715-.2.222-.132.375-.316.453-.542a.78.78 0 01.719-.441c.304 0 .546.12.714.363a.687.687 0 01.055.757 2.79 2.79 0 01-1.062 1.227A2.897 2.897 0 016.59 3.5c-.258 0-.496.059-.719.176a.912.912 0 00-.45.535.96.96 0 01-.288.344.73.73 0 01-.434.129zm0 0"
          fill="currentColor"
        />
      </g>
    </svg>
  );
};
const MemoSvgHousehold = React.memo(SvgHousehold);
export default MemoSvgHousehold;
